import { render, staticRenderFns } from "./factory-multiselect-ajax.vue?vue&type=template&id=3f701e4a&scoped=true&"
import script from "./factory-multiselect-ajax.vue?vue&type=script&lang=js&"
export * from "./factory-multiselect-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f701e4a",
  null
  
)

export default component.exports